const STATES = {
  delivered: 'Entregado',
};

export default STATES;
